import { render, staticRenderFns } from "./sop-validations.vue?vue&type=template&id=cb96fe12"
import script from "./sop-validations.vue?vue&type=script&lang=js"
export * from "./sop-validations.vue?vue&type=script&lang=js"
import style0 from "./sop-validations.vue?vue&type=style&index=0&id=cb96fe12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports